import React, { useCallback, useState } from 'react';
import DotsHorizontalIcon from '@heroicons/react/outline/DotsHorizontalIcon.js';
import PencilAltIcon from '@heroicons/react/outline/PencilAltIcon.js';
import PlusIcon from '@heroicons/react/outline/PlusIcon.js';
import TrashIcon from '@heroicons/react/outline/TrashIcon.js';
import ViewListIcon from '@heroicons/react/outline/ViewListIcon.js';
import { hasScopesPermission } from '@tribeplatform/gql-client/lib';
import { CollectionDeleteModal, CollectionFormModal, CollectionOrganizationModal, } from '@tribeplatform/react-components/Collection';
import { T } from '@tribeplatform/react-components/i18n';
import { CreateSpaceFromTemplateModal as CreateSpaceModal } from '@tribeplatform/react-components/Space';
import { useNetwork } from '@tribeplatform/react-sdk/hooks';
import { Button } from '@tribeplatform/react-ui-kit/Button';
import { Dropdown } from '@tribeplatform/react-ui-kit/Dropdown';
export const CollectionHeaderActionButtons = ({ collection, }) => {
    const [openOrganizationModal, setOpenOrganizationModal] = useState(false);
    const [openSpaceModal, setOpenSpaceModal] = useState(false);
    const [openCollectionModal, setOpenCollectionModal] = useState(false);
    const [openDeleteCollectionModal, setOpenDeleteCollectionModal] = useState(false);
    const { data: network = {} } = useNetwork();
    const [canCreateSpace, canCreateCollection] = hasScopesPermission(network, [
        'addSpace',
        'createCollection',
    ]);
    const onOrganizationModalClose = useCallback(() => {
        setOpenOrganizationModal(false);
    }, []);
    const onOrganizeClick = useCallback(() => {
        setOpenOrganizationModal(true);
    }, []);
    const onDeleteClick = useCallback(() => {
        setOpenDeleteCollectionModal(true);
    }, []);
    const closeCollectionModal = useCallback(() => {
        setOpenCollectionModal(false);
    }, []);
    const deleteCollectionModal = useCallback(() => {
        setOpenDeleteCollectionModal(false);
    }, []);
    const closeCreateSpaceModal = useCallback(() => {
        setOpenSpaceModal(false);
    }, []);
    const openCreateSpaceModal = useCallback(() => {
        setOpenSpaceModal(true);
    }, []);
    const openEditCollectionModal = useCallback(() => {
        setOpenCollectionModal(true);
    }, []);
    return (React.createElement(React.Fragment, null,
        canCreateCollection && (React.createElement(Dropdown, { placement: "bottom-end" },
            React.createElement(Dropdown.ButtonMinimal, null,
                React.createElement(Button, { variant: "outline", leadingIcon: React.createElement(DotsHorizontalIcon, null) })),
            React.createElement(Dropdown.Items, { className: "-mt-2" },
                React.createElement(Dropdown.Item, { leadingIcon: React.createElement(PencilAltIcon, null), onClick: openEditCollectionModal },
                    React.createElement(T, { id: "Blocks.CollectionHeader.EditCollection", defaultMessage: "Edit {COLLECTION}" })),
                React.createElement(Dropdown.Item, { leadingIcon: React.createElement(ViewListIcon, null), onClick: onOrganizeClick },
                    React.createElement(T, { id: "Generics.Organize", defaultMessage: "Organize" })),
                React.createElement(Dropdown.Item, { leadingIcon: React.createElement(TrashIcon, null), onClick: onDeleteClick },
                    React.createElement(T, { id: "Blocks.CollectionHeader.DeleteCollection", defaultMessage: "Delete {COLLECTION}" }))))),
        openCollectionModal && (React.createElement(CollectionFormModal, { open: openCollectionModal, collection: collection, onClose: closeCollectionModal })),
        openDeleteCollectionModal && (React.createElement(CollectionDeleteModal, { open: openDeleteCollectionModal, onClose: deleteCollectionModal, collection: collection })),
        canCreateSpace && (React.createElement(Button, { leadingIcon: React.createElement(PlusIcon, null), onClick: openCreateSpaceModal },
            React.createElement(T, { id: "Generics.AddSpace", defaultMessage: "Add {SPACE}" }))),
        openSpaceModal ? (React.createElement(CreateSpaceModal, { open: openSpaceModal, space: {
                collectionId: collection === null || collection === void 0 ? void 0 : collection.id,
            }, onClose: closeCreateSpaceModal })) : null,
        openOrganizationModal && (React.createElement(CollectionOrganizationModal, { open: openOrganizationModal, onClose: onOrganizationModalClose, collection: collection }))));
};
//# sourceMappingURL=CollectionHeaderActionButtons.js.map